<template>
  <b-overlay :opacity="'0.5'" :show="onGoingCalls > 0" rounded="sm">
    <div>
      <link rel="stylesheet" :href="require('../../../../assets/css/vue-select.css')">
      <div class="settings-row" style="padding: 5px auto; margin-bottom: 0 !important; margin-top: 0 !important; background-color: #F7F7F7;">
        <i class="mdi mdi-cog" aria-hidden="true"></i>&nbsp;{{ $t('settings.settings') }}
      </div>
      <div style="height: 100%; width: 100%; overflow-y: scroll; padding: 0 30px 0 30px; background-color: #FFFFFF;">
        <div class="settings-sub-row" style="background-color: #009AB1; color: white; padding: 10px 10px; text-align: center !important;">
          <span>
            {{ name }}
            <br /><span style="font-size: 0.9rem;" v-if="extension">{{ $t('settings.extension') }}: {{ extension }}</span>
            <br /><span style="font-size: 0.9rem;" v-if="fonenumber">{{ $t('settings.callerID') }}: {{ fonenumber }}</span>
          </span>
        </div>
        <div class="settings-sub-row settings-sub-row-hover" @click="showFones" v-if="!fractelfone">
          <span>
            <i class="mdi mdi-swap-horizontal-variant" aria-hidden="true"></i>&nbsp;{{ $t('settings.switch', { appName: $whitelabel.getAppName() }) }}
          </span>
        </div>
        <transition name="fade">
          <div class="settings-sub-row settings-sub-row-hover" v-if="fones">
            <v-select
              v-model="device"
              v-bind:options="devices"
              :clearable="false"
              :loading="foneProcessing"
              @input="switchFone"
              >
              <template #spinner="{ loading }">
                <div v-if="foneProcessing" style="border-left-color: rgba(0,154,177,0.71)" class="vs__spinner">
                </div>
              </template>
            </v-select>
          </div>
        </transition>
        <div class="settings-sub-row settings-sub-row-hover" @click="showCallerID" v-if="!fractelfone">
          <span>
            <i class="mdi mdi-numeric" aria-hidden="true"></i>&nbsp;{{ $t('settings.callerID') }}
          </span>
        </div>
        <transition name="fade">
          <div class="settings-sub-row settings-sub-row-hover" v-if="callerID">
            <v-select
              v-model="fonenumber"
              v-bind:options="fonenumbers"
              :clearable="false"
              :loading="processing"
              @input="fonenumberSelect"
              >
              <template #spinner="{ loading }">
                <div v-if="processing" style="border-left-color: rgba(0,154,177,0.71)" class="vs__spinner">
                </div>
              </template>
            </v-select>
          </div>
        </transition>
        <div class="settings-sub-row settings-sub-row-hover" @click="showTimes">
          <span>
            <i class="mdi mdi-clock" aria-hidden="true"></i>&nbsp;{{ $t('settings.timeFormat') }}
          </span>
        </div>
        <transition name="fade">
          <div class="settings-sub-row settings-sub-row-hover" v-if="timeFormating">
            <v-select
              v-model="timeFormat"
              v-bind:options="timeFormats"
              :clearable="false"
              @input="switchTimeFormat"
              />
          </div>
        </transition>
        <div class="settings-sub-row settings-sub-row-hover" @click="showDND">
          <span>
            <i class="mdi mdi-minus-circle" aria-hidden="true"></i>&nbsp;{{ $t('settings.doNotDisturb') }}
          </span>
        </div>
        <transition name="fade">
          <div class="settings-sub-row settings-sub-row-hover" v-if="editDND">
            <v-select
              v-model="DND"
              v-bind:options="DNDoptions"
              :clearable="false"
              @input="switchDND"
              />
          </div>
        </transition>
        <div class="settings-sub-row settings-sub-row-hover" @click="logout">
          <span>
            <i class="mdi mdi-logout" aria-hidden="true"></i>&nbsp;{{ $t('settings.logout') }}
          </span>
        </div>
      </div>
    </div>
    <template v-slot:overlay>
      <div class="text-center">
        <span><b-spinner variant="teal" type="grow" small></b-spinner>{{ $t('settings.onCall') }}...</span>
      </div>
    </template>
  </b-overlay>
</template>

<script>
import axios from 'axios'
import vSelect from 'vue-select'

export default {
  name: 'Settings',
  components: {
    'v-select': vSelect
  },
  mounted: async function () {
    var self = this
    try {
      self.processing = true
      self.foneProcessing = true
      self.device = {
        label: self.name,
        code: localStorage.getItem('device')
      }
      var response = await axios.get(`${process.env.FONESTORM_API}/fonenumbers?active=yes`, { headers: { token: localStorage.getItem('fonestorm-token') } })
      self.fonenumbers = response.data.fonenumbers
      response = await axios.get(`${process.env.FONESTORM_API}/devices/${localStorage.getItem('device')}/verto`, { headers: { token: localStorage.getItem('fonestorm-token') } })
      self.fonenumber = response.data.device.fonenumber

      response = await axios.get(`${process.env.FONESTORM_API}/devices`, { headers: { token: localStorage.getItem('fonestorm-token') } })
      response.data.devices.forEach((device) => {
        if (device.type === 'fractelfone' || device.type === 'webrtc device') {
          self.devices.push({
            label: device.name,
            code: device.id
          })
        }
      })
      self.processing = false
      self.foneProcessing = false
    } catch (error) {
      self.processing = false
      self.foneProcessing = false
      if (error.response.status === 401) {
        self.$router.push({ name: 'Login' })
      }
    }
  },
  props: {
    name: {
      type: String,
      required: false
    },
    extension: {
      type: String,
      required: false
    },
    windowWidth: {
      type: Number
    },
    onGoingCalls: {
      type: Number,
      default: 0
    },
    vertoHandle: {
      type: Object,
      required: true
    },
    fractelfone: {
      type: String
    },
    io: {
      type: Object
    },
    DNDchange: {
      type: Function
    }
  },
  data () {
    return {
      fonenumber: null,
      fonenumbers: [],
      device: null,
      devices: [],
      timeFormat: localStorage.getItem('timeFormat') === 'true' ? '12 hour' : '24 hour',
      timeFormats: ['24 hour', '12 hour'],
      DNDoptions: ['On', 'Off'],
      callerID: false,
      fones: false,
      timeFormating: false,
      processing: false,
      foneProcessing: false,
      editDND: false,
      DND: localStorage.getItem('DND') || 'Off'
    }
  },
  methods: {
    fonenumberSelect: async function() {
      var self = this

      try {
        if (self.fonenumber) {
          self.processing = true
          await axios.put(`${process.env.FONESTORM_API}/devices/${localStorage.getItem('device')}`, { fonenumber: self.fonenumber },{ headers: { token: localStorage.getItem('fonestorm-token') } })
          self.processing = false
        }
      } catch (error) {
        self.processing = false
        if (error.response.status === 401) {
          self.$router.push({ name: 'Login' })
        }
      }
    },
    showCallerID () {
      var self = this
      self.fones = false
      self.timeFormating = false
      self.editDND = false
      self.callerID = !self.callerID
    },
    switchFone () {
      var self = this
      localStorage.setItem('device', self.device.code)
      if (self.windowWidth < 800) {
        window.resizeTo(420, 604)
      }
      self.$router.go()
    },
    showFones () {
      var self = this
      self.callerID = false
      self.timeFormating = false
      self.editDND = false
      self.fones = !self.fones
    },
    switchTimeFormat () {
      var self = this
      var ampm = self.timeFormat === '12 hour'
      localStorage.setItem('timeFormat', ampm)
    },
    showTimes () {
      var self = this
      self.callerID = false
      self.fones = false
      self.editDND = false
      self.timeFormating = !self.timeFormating
    },
    switchDND () {
      var self = this
      self.DNDchange(self.DND)
      localStorage.setItem('DND', self.DND)
    },
    showDND () {
      var self = this
      self.callerID = false
      self.fones = false
      self.timeFormating = false
      self.editDND = !self.editDND
    },
    logout () {
      var self = this
      if (self.windowWidth < 800) {
        window.resizeTo(420, 604)
      }
      self.vertoHandle.rpcClient.closeSocket()
      self.vertoHandle.rpcClient.stopRetrying()
      self.io.disconnect()
      self.$router.push({ name: 'Login' })
    }
  }
}

</script>

<style lang="scss">
.settings-row {
  margin: 20px auto !important;
  width: auto;
  height: auto !important;
  clear: both !important;
}

.settings-sub-row {
  margin: 20px auto !important;
  width: auto;
  height: auto !important;
  clear: both !important;
  text-align: left !important;
}

.settings-sub-row-hover:hover {
  color: #009AB1 !important;
  cursor: pointer;
}

.vs__dropdown-menu {
  max-height: 200px !important;
}

.vs__dropdown-option--highlight {
  background-color: #009AB1 !important;
}

.text-teal {
  color: #009AB1;
}
</style>
